export default __webpack_public_path__ + "static/media/slider-1.9722fc0d.jpeg";